(function($){
    $(document).ready(function(){
        initParticipatingHotelsCarousel();
    });

    function initParticipatingHotelsCarousel(){
        var wraps = $('.participating_hotels.layout_carousel_full');
        if(wraps.length === 0){ return; }

        wraps.each(function(){
            var wrap = $(this);
            var slider = wrap.find('.children_section'),
                slickSlide = slider.find('.item_wrap'),
                image = slider.find('.thumb a'),
                prevTitle = slider.find('.prev_title');
            var slidesCount = slider.children().length;
            var status = wrap.find('.pagingInfo');
            var pagerWrap = wrap.find('.pager_wrap');
            var slidesNum = 0, hasCarousel = false;

            if (is_phone) {
                slidesNum = 1;
                if (slidesCount > 1) { hasCarousel = true; }
            } else if (is_mobile) {
                slidesNum = 2;
                if (slidesCount > 2) { hasCarousel = true; }
            } else {
                slidesNum = 3;
                if (slidesCount >= 3) { hasCarousel = true; }
            }

            wrap.on('init reInit afterChange', function (event, slick, currentSlide) {
                var i = ((currentSlide) ? (currentSlide / slidesNum) : 0) + 1;
                status.text(i + '/' + Math.ceil(slick.slideCount / slidesNum));
                if (is_phone && slidesCount < 2) {
                    pagerWrap.css('display', 'none');
                } else if (is_tablet_portrait && slidesCount < 3 || is_desktop && slidesCount <= 3) {
                    pagerWrap.css('display', 'none');
                }
            });

            slider.on('init', function(){
                if (typeof lazyLoadInstance !== 'undefined') {
                    lazyLoadInstance.update();
                }
            });

            if (hasCarousel) {
                slider.slick({
                    autoplay: false,
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: true,
                    dots: false,
                    rows: 0,
                    prevArrow: accor_arrow_prev,
                    nextArrow: accor_arrow_next,
                    appendArrows: wrap.find('.pager_wrap'),
                    appendDots: wrap.find('.pager'),
                    variableWidth: false,
                    centerMode: false,
                    rtl: $('html').attr('dir') == 'rtl',
                    responsive: [
                        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                        { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: true } }
                    ]
                });
            } else {
                pagerWrap.css('display', 'none');
            }

            slickSlide.attr('tabindex', '-1');
            image.attr('tabindex', '-1');
            prevTitle.attr('tabindex', '-1');

            slider.on('afterChange', function () {
                setTimeout(function () {
                    slickSlide.attr('tabindex', '-1');
                    image.attr('tabindex', '-1');
                    prevTitle.attr('tabindex', '-1');
                }, 5)
            });
        });
    }
})(jQuery);
